import request from '@/utils/request'

export function getHistoryBreakfast(params) {
  return request({
    url: '/config-service/v1/breakfast-history/history',
    method: 'get',
    params: params
  })
}
export function setHistoryBreakfast(payload) {
  return request({
    url: '/config-service/v1/breakfast-history',
    method: 'post',
    data: payload
  })
}
